import { ColumnsType } from 'antd/es/table';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import dayjs from 'dayjs';
import { actionIconMapper, actionTitleMapper, HistoryAction, useGetPaginatedHistoryQuery } from 'entities/History';
import { FC, memo, useMemo } from 'react';
import { Modal } from 'shared/ui/Modal';
import { ServerTable } from 'shared/ui/ServerTable';

interface HistoryModalProps {
  isOpened: boolean;
  email: string | undefined;
  loggedUserEmail: string | undefined;
  onCLose: () => void;
}

export const HistoryModal: FC<HistoryModalProps> = memo((props) => {
  const { isOpened, email, loggedUserEmail, onCLose } = props;

  const { t } = useAppTranslation('profile');

  const columns = useMemo<ColumnsType<HistoryAction>>(
    () => [
      {
        key: 'icon',
        render: (_, record) => {
          const icon = actionIconMapper(record.actionName);

          return icon;
        },
      },
      {
        title: t('Subject'),
        key: 'subject',
        render: (_, record) => {
          const { subject } = actionTitleMapper(record.actionName, record.actionData, t);

          const subjectName = subject === loggedUserEmail ? t('You') : subject;

          return subjectName;
        },
      },
      {
        title: t('Action'),
        key: 'action',
        render: (_, record) => {
          const { action } = actionTitleMapper(record.actionName, record.actionData, t);

          return action;
        },
      },
      {
        title: t('Object'),
        key: 'object',
        render: (_, record) => {
          const { object } = actionTitleMapper(record.actionName, record.actionData, t);

          return object;
        },
      },
      { title: t('Date'), key: 'date', render: (_, record) => dayjs(record.updatedAt || record.createdAt).fromNow() },
    ],
    [loggedUserEmail, t],
  );

  return (
    <Modal width={1200} isOpen={isOpened} onClose={onCLose}>
      <ServerTable columns={columns} fetchData={useGetPaginatedHistoryQuery} defaultFilters={{ userName: email }} rowKey="userId" />
    </Modal>
  );
});
